import React, { Component, ReactNode } from "react";
import { type LucideIcon } from "lucide-react";

interface PageTitleProps {
    heading: string;
    icon: LucideIcon;
    subheading?: string | null;
    /** Optional right-side content (filters, actions, etc.) */
    actions?: ReactNode;
}

class PageTitle extends Component<PageTitleProps> {
    render() {
        const { heading, icon: Icon, subheading, actions } = this.props;

        return (
            <div className="px-1 py-4 mb-4 transition-all duration-200">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-xl bg-primary-50 dark:bg-primary-900/20 flex items-center justify-center flex-shrink-0">
                            <Icon size={18} strokeWidth={1.75} className="text-primary-600 dark:text-primary-400" />
                        </div>
                        <div>
                            <h1 className="text-lg font-semibold bg-gradient-to-r from-neutral-900 to-neutral-700 dark:from-neutral-100 dark:to-neutral-300 bg-clip-text text-transparent leading-tight">
                                {heading}
                            </h1>
                            {subheading && (
                                <p className="text-sm text-neutral-500 dark:text-neutral-400 mt-0.5">
                                    {subheading}
                                </p>
                            )}
                        </div>
                    </div>
                    {actions && <div className="flex items-center gap-2">{actions}</div>}
                </div>
            </div>
        );
    }
}

export default PageTitle;
